// TermsOfService.jsx
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { NULL_FUNCTION } from '../resource/defaults.js';
import { LegalPageLayout } from '../component/LegalPageLayout.jsx';

const TermsOfService = ({
  t,
  goBack = NULL_FUNCTION,
  handleMailTo = NULL_FUNCTION,
}) => (
  <LegalPageLayout
    title={t('seo_tos_h1', { ns: TranslationNamespace.SEO })}
    htmlString={t('tos_seo_description', {
      ns: TranslationNamespace.SETTINGS,
      interpolation: { prefix: '#__NONE__#', suffix: '#__NONE__#' },
    })}
    goBack={goBack}
    onMailTo={handleMailTo}
  />
);

TermsOfService.propTypes = {
  goBack: PropTypes.func,
  handleMailTo: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export { TermsOfService };
export default withTranslation()(memo(TermsOfService));
